import { find, propEq } from 'ramda';

export const createFormatter = options => ({ value }) => {
  const option = find(propEq('key', value), options);

  return option.label;
};
